import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { connect, useSelector, useDispatch } from "react-redux";
import {
  ManageServiceList,
  multiServicesDelete,
} from "../../redux/action/services";
import ViewService from "./ViewService";
import { serviceDelete } from "../../redux/action/services";
import { ToastContainer } from "react-toastify";
import NoImage from "../../assets/images/noimages.jpg";
import { APIURL } from "../../redux/action/config";
import search from "../../utils/search";
import Pagination from "./../../components/Pagination";
import { CSVLink } from "react-csv";
import TableStatusRow from "../../components/loader/TableStatusRow";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const ServiceList = ({ pageLoading, serviceListData, not_found }) => {
  const [productDataList, setProductDataList] = useState([]);
  const [tooltipId, setToolTipId] = useState('')
  const onChangePage = (pageOfItems) => {
    setProductDataList(pageOfItems);
  };

  const [viewDetails, setViewDetails] = useState();

  const [id, setId] = useState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const loadList = async () => {
    setLoading(true);
    try {
      await dispatch(ManageServiceList());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadList();
  }, [dispatch, id]);

  const handleGetId = (e, id) => {
    e?.preventDefault();
    if (!id) return;
    if (id !== undefined) {
      setViewDetails("");
      const token = localStorage.getItem("token");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${APIURL}/api/v1/services/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setViewDetails(result?.data?.service);
        })
        .catch((error) => console.log("error", error));
    }
  };

  const services = serviceListData?.data?.shortedServices
    ? serviceListData?.data?.shortedServices
    : "";

  const sortlist = services
    ? services?.sort(function (a, b) {
      return a.parentId - b.parentId;
    })
    : "";

  const servicesDel = (id) => {
    dispatch(serviceDelete(id));
    setTimeout(() => {
      loadList();
    }, 1000);
  };

  const truncate = (input) => {
    if (input?.length > 20) {
      return input?.substring(0, 20) + "...";
    }
    return input;
  };

  const truncateChild = (input) => {
    if (input?.length > 0) {
      return input?.substring(0, 0) + "...";
    }
    return input;
  };

  const headers = [
    { label: "_id", key: "id" },
    { label: "Service Name", key: "name" },
    { label: "Detail", key: "detail" },
    { label: "Price($)", key: "price" },
    { label: "SubServeicePrice($)", key: "subServeicePrice" },
    { label: "Created_At", key: "created" },
    { label: "Updated_At", key: "updated" },
  ];

  const data = productDataList
    ? productDataList?.map((item) => {
      return {
        id: item?._id ? item?._id : "N/A",
        name: item.name ? item.name : "N/A",
        detail: item?.detail ? item?.detail : "N/A",
        price: item?.price ? item?.price : "N/A",
        subServeicePrice: item?.subServeicePrice
          ? item?.subServeicePrice
          : "N/A",
        created: item?.createdAt ? item?.createdAt : "N/A",
        updated: item?.updatedAt ? item?.updatedAt : "N/A",
      };
    })
    : "";

  // *********** All Select Delete ***********
  // const [btnStatus, setBtnStatus] = useState(false);
  // const [isCheckAll, setIsCheckAll] = useState(false);
  // const [isCheck, setIsCheck] = useState([]);
  // const [list, setList] = useState([]);

  // useEffect(() => {
  //   setList(productDataList);
  // }, [productDataList]);

  // const handleSelectAll = (e) => {
  //   setIsCheckAll(!isCheckAll);
  //   setIsCheck(list.map((li) => li.id));
  //   if (isCheckAll) {
  //     setIsCheck([]);
  //   }
  // };

  // const handleClick = (e) => {
  //   const { id, checked } = e.target;
  //   setIsCheck([...isCheck, id]);
  //   if (!checked) {
  //     setIsCheck(isCheck.filter((item) => item !== id));
  //   }
  // };

  // const handleAllDelete = () => {
  //   multiServicesDelete(isCheck);
  //   setTimeout(() => {
  //     dispatch(ManageServiceList());
  //     setIsCheckAll(false);
  //     setIsCheck([]);
  //   }, 1000);
  // };

  // pdf code start
  const downloadPDF = () => {
    const capture = document.querySelector(".table");
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      console.log("Image Data:", imgData); // Debugging: Log the image data
      const doc = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
      doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      doc.save("roadside-response.pdf");
    });
  };
  // pdf code end

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Services List" page="services">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row pt-4 pb-4">
              <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                <div
                  className="dataTables_length"
                  id="kt_datatable_example_5_length"
                >
                  {/* {isCheck && isCheck?.length > 0 ? (
                    <button
                      onClick={() => {
                        handleAllDelete();
                      }}
                      className="delete-selected"
                    >
                      Delete Selected
                    </button>
                  ) : (
                    ""
                  )} */}
                  {/* <label>
                    Show
                    <select
                      name="kt_datatable_example_5_length"
                      aria-controls="kt_datatable_example_5"
                      className="form-select form-select-sm form-select-solid"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label> */}
                </div>
              </div>
              <div className="col-sm-6 d-flex align-items-center justify-content-end">
                <div
                  id="kt_datatable_example_5_filter"
                  className="dataTables_filter"
                >
                  <label>
                    Search:
                    <input
                      type="search"
                      onChange={() => {
                        search();
                      }}
                      id="myInput"
                      className="form-control form-control-sm form-control-solid"
                      placeholder=""
                      aria-controls="kt_datatable_example_5"
                    />
                  </label>
                </div>
                <div className="ms-3">
                  <a
                    className="btn pgf btn-secondary dropdown-toggle"
                    href="#"
                    // role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    // className="csvlink"
                    style={{ background: "none" }}
                  >
                    Download File
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item">
                        <CSVLink
                          style={{ color: "#000" }}
                          data={data}
                          headers={headers}
                        >
                          Download as CSV
                        </CSVLink>
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" onClick={downloadPDF}>
                        Download as PDF
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="table-responsive table-wrapper">
              <table
                id="kt_datatable_example_5"
                className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer"
              >
                <thead>
                  <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                    {/* <th style={{ padding: "16px 0px 16px 24px" }}>
                      <input
                        type="checkbox"
                        name="selectAll"
                        id="selectAll"
                        onClick={() => {
                          handleSelectAll();
                          setBtnStatus(true);
                        }}
                        checked={isCheckAll}
                        className="form-check-input custum-check"
                      />
                    </th> */}
                    <th style={{ width: "142.125px" }}>Service Icon</th>
                    <th>Service Name</th>
                    <th>Tooltip</th>
                    <th>Price($)</th>
                    <th>Sub Service Price($)</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading || (!productDataList?.length && services?.length) ? (
                    <TableStatusRow loading colSpan={6} />
                  ) : productDataList?.length ? (
                    productDataList?.map((itemss, index) => {
                      const parentImageSource = itemss?.image ? (APIURL + "/" + itemss.image) : NoImage;
                      return (
                        <>
                          <tr key={index}>
                            <td>
                              <img
                                className="service-img"
                                src={parentImageSource}
                                alt="service icon"
                              />
                            </td>
                            <td>{itemss.name}</td>
                            <td onMouseEnter={() => setToolTipId(itemss.id)} onMouseLeave={() => setToolTipId('')} className="position-relative">{truncate(itemss.detail)}
                              {tooltipId == itemss.id && <p className="position-absolute text-white bg-black rounded-1 top-25" style={{ maxWidth: '175px' }}>{itemss.detail}</p>}
                            </td>
                            <td>
                              {itemss?.child && itemss?.child?.length > 0
                                ? "N/A"
                                : `$${itemss.price}`}
                            </td>
                            <td>${itemss.subServeicePrice}</td>
                            <td>
                              <a
                                type="button"
                                onClick={(e) => handleGetId(e, itemss?.id)}
                                className="btn btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#serviceDetailModal"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-eye-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                </svg>
                              </a>
                              <ViewService
                                modalId={"serviceDetailModal"}
                                viewDetails={viewDetails ? viewDetails : ""}
                              />
                              {/* <Link
                                to="#"
                                onClick={() => setId(itemss.id)}
                                className="btn btn-bg-primary action-hover"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-eye-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                </svg>
                              </Link> */}
                              <Link
                                to={`/edit-service/${itemss.id}`}
                                onClick={() => setId(itemss.id)}
                                className="btn btn-info"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-pencil-square"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                  <path
                                    fillRule="evenodd"
                                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                  ></path>
                                </svg>
                              </Link>
                              <Link
                                to="/manage-service"
                                onClick={() => servicesDel(itemss.id)}
                                className="btn btn-bg-dark action-hover"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-trash-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                </svg>
                              </Link>
                            </td>
                          </tr>
                          {itemss?.child?.map((item) => {
                            console.log('item', item)
                            return (
                              <>
                                <tr key={index}>
                                  {/* <td
                                    style={{ width: "20px" }}
                                    className="check-list"
                                  >
                                    <input
                                      type="checkbox"
                                      name={item?.name}
                                      id={item?.id}
                                      onClick={(e) => handleClick(e)}
                                      checked={isCheck.includes(item?.id)}
                                      className="form-check-input custum-check"
                                    />
                                  </td> */}
                                  <td style={{ paddingLeft: "90px" }}>
                                    <img
                                      className="service-img"
                                      src={item.image ? APIURL + "/" + item.image : NoImage}
                                      alt="profile"
                                    />
                                  </td>
                                  <td>{item.name}</td>
                                  <td>{truncateChild(item.detail)}</td>
                                  <td></td>
                                  <td>${item.subServeicePrice}</td>
                                  <td>
                                    <a
                                      type="button"
                                      onClick={(e) => handleGetId(e, item?.id)}
                                      className="btn btn-primary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#serviceDetailModal"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-eye-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                      </svg>
                                    </a>
                                    <ViewService
                                      modalId={"serviceDetailModal"}
                                      id={id ? id : ""}
                                    />
                                    {/* <Link
                                      to="#"
                                      onClick={() => setId(item.id)}
                                      className="btn btn-bg-primary action-hover"
                                      data-bs-toggle="modal"
                                      data-bs-target="#exampleModal"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-eye-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                      </svg>
                                    </Link> */}
                                    <Link
                                      to={`/edit-service/${item.id}`}
                                      onClick={() => setId(item.id)}
                                      className="btn btn-info action-hover"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-pencil-square"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                        <path
                                          fillRule="evenodd"
                                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                        ></path>
                                      </svg>
                                    </Link>
                                    <Link
                                      to="/manage-service"
                                      onClick={() => servicesDel(item.id)}
                                      className="btn btn-bg-dark action-hover"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-trash-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                      </svg>
                                    </Link>
                                  </td>
                                </tr>
                                {item?.child?.map((item) => {
                                  console.log(item,"121324345");
                                  return (
                                    <>
                                      <tr key={index}>
                                        {/* <td
                                          style={{ width: "20px" }}
                                          className="check-list"
                                        >
                                          <input
                                            type="checkbox"
                                            name={item?.name}
                                            id={item?.id}
                                            onClick={(e) => handleClick(e)}
                                            checked={isCheck.includes(item?.id)}
                                            className="form-check-input custum-check"
                                          />
                                        </td> */}
                                        <td style={{ paddingLeft: "110px" }}>
                                          <img
                                            className="service-img"
                                            src={item.image ? APIURL + "/" + item.image : NoImage}
                                            alt="profile"
                                          />
                                        </td>
                                        <td>{item.name}</td>
                                        <td>{truncateChild(item.detail)}</td>
                                        <td></td>
                                        <td>${item.subServeicePrice}</td>
                                        <td>
                                          <ViewService
                                            modalId={"exampleModal"}
                                            id={id ? id : ""}
                                          />
                                          <Link
                                            to="#"
                                            onClick={() => setId(item.id)}
                                            className="btn btn-bg-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModal"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-eye-fill"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                            </svg>
                                          </Link>
                                          <Link
                                            to={`/edit-service/${item.id}`}
                                            onClick={() => setId(item.id)}
                                            className="btn btn-info"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-pencil-square"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                              <path
                                                fillRule="evenodd"
                                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                              ></path>
                                            </svg>
                                          </Link>
                                          <Link
                                            to="/manage-service"
                                            onClick={() => servicesDel(item.id)}
                                            className="btn btn-bg-dark"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-trash-fill"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                            </svg>
                                          </Link>
                                        </td>
                                      </tr>
                                      {item?.child?.map((item) => {
                                        return (
                                          <>
                                            <tr key={index}>
                                              {/* <td
                                                style={{ width: "20px" }}
                                                className="check-list"
                                              >
                                                <input
                                                  type="checkbox"
                                                  name={item?.name}
                                                  id={item?.id}
                                                  onClick={(e) =>
                                                    handleClick(e)
                                                  }
                                                  checked={isCheck.includes(
                                                    item?.id
                                                  )}
                                                  className="form-check-input custum-check"
                                                />
                                              </td> */}
                                              <td
                                                style={{ paddingLeft: "130px" }}
                                              >
                                                <img
                                                  className="service-img"
                                                  src={
                                                    item.image
                                                      ? APIURL + "/" +  item.image
                                                      : NoImage
                                                  }
                                                  alt="profile"
                                                />
                                              </td>
                                              <td>{item.name}</td>
                                              <td>
                                                {truncateChild(item.detail)}
                                              </td>
                                              <td></td>
                                              <td>${item.subServeicePrice}</td>
                                              <td>
                                                <ViewService
                                                  modalId={"exampleModal"}
                                                  id={id ? id : ""}
                                                />
                                                <Link
                                                  to="#"
                                                  onClick={() => setId(item.id)}
                                                  className="btn btn-bg-primary"
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#exampleModal"
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-eye-fill"
                                                    viewBox="0 0 16 16"
                                                  >
                                                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                                  </svg>
                                                </Link>
                                                <Link
                                                  to={`/edit-service/${item.id}`}
                                                  onClick={() => setId(item.id)}
                                                  className="btn btn-info"
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-pencil-square"
                                                    viewBox="0 0 16 16"
                                                  >
                                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                                    <path
                                                      fillRule="evenodd"
                                                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                                    ></path>
                                                  </svg>
                                                </Link>
                                                <Link
                                                  to="/manage-service"
                                                  onClick={() =>
                                                    servicesDel(item.id)
                                                  }
                                                  className="btn btn-bg-dark"
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-trash-fill"
                                                    viewBox="0 0 16 16"
                                                  >
                                                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                                  </svg>
                                                </Link>
                                              </td>
                                            </tr>
                                            {item?.child?.map((item) => {
                                              return (
                                                <tr key={index}>
                                                  {/* <td
                                                    style={{ width: "20px" }}
                                                    className="check-list"
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      name={item?.name}
                                                      id={item?.id}
                                                      onClick={(e) =>
                                                        handleClick(e)
                                                      }
                                                      checked={isCheck.includes(
                                                        item?.id
                                                      )}
                                                      className="form-check-input custum-check"
                                                    />
                                                  </td> */}
                                                  <td
                                                    style={{
                                                      paddingLeft: "150px",
                                                    }}
                                                  >
                                                    <img
                                                      className="service-img"
                                                      src={
                                                        item.image
                                                          ? APIURL + "/" +  item.image
                                                          : NoImage
                                                      }
                                                      alt="profile"
                                                    />
                                                  </td>
                                                  <td>{item.name}</td>
                                                  <td>
                                                    {truncateChild(item.detail)}
                                                  </td>
                                                  <td></td>
                                                  <td>
                                                    ${item.subServeicePrice}
                                                  </td>
                                                  <td>
                                                    <ViewService
                                                      modalId={"exampleModal"}
                                                      id={id ? id : ""}
                                                    />

                                                    <Link
                                                      to="#"
                                                      onClick={() =>
                                                        setId(item.id)
                                                      }
                                                      className="btn btn-bg-primary"
                                                      data-bs-toggle="modal"
                                                      data-bs-target="#exampleModal"
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-eye-fill"
                                                        viewBox="0 0 16 16"
                                                      >
                                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                                      </svg>
                                                    </Link>
                                                    <Link
                                                      to={`/edit-service/${item.id}`}
                                                      onClick={() =>
                                                        setId(item.id)
                                                      }
                                                      className="btn btn-info"
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-pencil-square"
                                                        viewBox="0 0 16 16"
                                                      >
                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                                        <path
                                                          fillRule="evenodd"
                                                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                                        ></path>
                                                      </svg>
                                                    </Link>
                                                    <Link
                                                      to="/manage-service"
                                                      onClick={() =>
                                                        servicesDel(item.id)
                                                      }
                                                      className="btn btn-bg-dark"
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-trash-fill"
                                                        viewBox="0 0 16 16"
                                                      >
                                                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                                      </svg>
                                                    </Link>
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </>
                                        );
                                      })}
                                    </>
                                  );
                                })}
                              </>
                            );
                          })}
                        </>
                      );
                    })
                  ) : (
                    <TableStatusRow colSpan={6} message="Data not found" />
                  )}
                </tbody>
              </table>
            </div>
            <Pagination
              pageSize={10}
              items={services}
              onChangePage={onChangePage}
            />
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.manageservice?.loading,
  serviceListData: state?.manageservice?.list,
  not_found: state?.manageservice?.not_found,
});

export default connect(mapStateToProps, { ManageServiceList, serviceDelete })(
  ServiceList
);